import apiUrl from '../../../../constants'
import axios from 'axios'
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import Paginate from 'vuejs-paginate'
import VueElementLoading from 'vue-element-loading';


export default {
  name: 'hub-inscan',
  components: {
		DatePicker,
		Paginate,
		VueElementLoading
	},
	props: [],
	data() {
		return {
			componentKey: 0,
			pageNo: 1,
			limit: 10,
			totalRows: 0,
			hubid:0,
			inScannedShipmentArray:[],
			pageCount: 0,
			showDeliveryTable:false,
			isLoading:false,
			Delivery:'',
			checkedType:'',
			checkedTypeError:'',
			showTable:false,
			reverseShipmentArray:[],
			showReverseTable:false,
			showRefresh:false
		}
	},
	computed: {
		// selects all checkbox's option
		currentTabComponent: function() {
			this.componentKey += 1
			return this.currentTab.toLowerCase()
		}
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext)
		this.hubid = userdetail[0].HubId[0];
	},
	methods: {
		getDeliveryShipments() {
			if(this.checkedType == 'delivery')
			{
			this.showRefresh=true;
			this.showReverseTable=false;
      this.totalRows = 0
      this.inScannedShipmentArray = []
      this.isLoading = true;
      this.input = ({});
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'getInScanShipments?CurrentHubID=' +this.hubid + '&PageNo=' + this.pageNo + '&PageSize=' + this.limit,
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          this.isLoading = false;
          if (result.data.ResultCode == 100) {
            this.inScannedShipmentArray = result.data.ResponseData;
            this.$alertify.success(result.data.ReturnMessage);
            this.totalRows = result.data.TotalShipments;
						this.showDeliveryTable=true;
            if (this.totalRows < 10) {
              this.pageCount = 1
            } else {
              this.pageCount = Math.ceil(this.totalRows / 10);
            }
          } else {
            this.$alertify.error(result.data.ReturnMessage);
          }
        }, error => {
          console.error(error)
        })
			}
			else{
				this.showRefresh=true;
				this.showDeliveryTable=false;
	      this.totalRows = 0
	      this.reverseShipmentArray = []
	      this.isLoading = true;
	      this.input = ({});
	      axios({
	          method: 'GET',
	          url: apiUrl.api_url_hubops + 'getReverseInScanShipments?CurrentHubID=' +this.hubid + '&PageNo=' + this.pageNo + '&PageSize=' + this.limit,
	          data: this.input,
	          headers: {
	            'authorization': 'authkey xB84JJ89Hd25'
	          }
	        })
	        .then(result => {
	          this.isLoading = false;
	          if (result.data.ResultCode == 100) {
	            this.reverseShipmentArray = result.data.ResponseData;
	            this.$alertify.success(result.data.ReturnMessage);
	            this.totalRows = result.data.TotalShipments;
							this.showReverseTable=true;
	            if (this.totalRows < 10) {
	              this.pageCount = 1
	            } else {
	              this.pageCount = Math.ceil(this.totalRows / 10);
	            }
	          } else {
	            this.$alertify.error(result.data.ReturnMessage);
	          }
	        }, error => {
	          console.error(error)
	        })

			}
    },
		getPaginationData(pageNum) {
			this.pageNo = (pageNum)
			this.getDeliveryShipments()
		},

	}
}



// WEBPACK FOOTER //
// ./src/views/components/HubInscan/ReloadInscanShipmentList/ReloadInscanShipmentList.js